export default __webpack_public_path__ + "static/background-image-98b0243247793026e3cd7c49515d7471.gif";